import { MOUTH_HOLD_DURATION_MS, MOUTH_OPEN_THRESHOLD } from '../constants';
import type { FrameResult } from '../types';
import { BaseChallenge } from './base-challenge';

const UPPER_LIP = 13;
const LOWER_LIP = 14;
const MOUTH_LEFT = 61;
const MOUTH_RIGHT = 291;

export class MouthOpenChallenge extends BaseChallenge {
  private holdStart: number | null = null;

  constructor() {
    super('mouth_open');
  }

  processFrame(frame: FrameResult): void {
    if (!frame.face?.landmarks || frame.face.landmarks.length < 300) {
      return;
    }

    this.captureFrame();

    const { landmarks } = frame.face;
    const upperLip = landmarks[UPPER_LIP];
    const lowerLip = landmarks[LOWER_LIP];
    const leftCorner = landmarks[MOUTH_LEFT];
    const rightCorner = landmarks[MOUTH_RIGHT];

    if (!upperLip || !lowerLip || !leftCorner || !rightCorner) return;

    const mouthWidth = Math.abs(rightCorner.x - leftCorner.x);
    if (mouthWidth < 0.001) return;

    const mouthRatio = Math.abs(lowerLip.y - upperLip.y) / mouthWidth;
    const isOpen = mouthRatio > MOUTH_OPEN_THRESHOLD;

    if (isOpen) {
      if (this.holdStart === null) {
        this.holdStart = Date.now();
      }
      const held = Date.now() - this.holdStart;
      const progress = Math.min(held / MOUTH_HOLD_DURATION_MS, 1);
      this.reportProgress(progress);

      if (held >= MOUTH_HOLD_DURATION_MS) {
        this.pass(0.9);
      }
    } else {
      this.holdStart = null;
      const progress = Math.min(mouthRatio / MOUTH_OPEN_THRESHOLD, 1);
      this.reportProgress(progress);
    }
  }
}
